<template>
  <div class="container">
    <shoutouts-programs-header-buttons :program="state.shoutoutsProgram.program" :tags="tags" />
    <shoutouts-programs-tabs class="m-bx4" initial-tab-value="show" />
    <shoutouts-programs-settings-points />
    <div class="separator m-vx2" />
    <shoutouts-programs-settings-channels :channel-phrase="channelPhrase" />
    <div class="separator m-vx2" />
    <shoutouts-programs-settings-recipients />
    <div class="separator m-vx2" />
    <template v-if="!upgradeRequired('reactions_enabled')">
      <shoutouts-programs-settings-reactions />
      <div class="separator m-vx2" />
    </template>
    <shoutouts-programs-settings-allowances />
    <div class="separator m-vx2" />
    <div v-tooltip="deactivationTooltip" class="w-x40">
      <button
        v-if="program.deactivatable"
        :class="`red inv w-100p ${program.state === 'active' ? '' : 'disabled'}`"
        @click="openDeactivateModal"
      >
        Deactivate {{ $i18n.t('shoutouts.feature') }}
      </button>
    </div>
  </div>
</template>

<script setup>
  import { computed, inject, onMounted } from 'vue';
  import { useStore } from 'vuex';
  import useClientState from 'composables/client-state';

  const { state, getters, commit, dispatch } = useStore();
  const { getQueryParam } = useClientState();

  const { tags, setupChannel, channelPhrase } = defineProps({
    tags: { type: Array, required: true },
    setupChannel: { type: Object, default: null },
    channelPhrase: { type: String, required: true },
  });
  const $i18n = inject('$i18n');

  const program = computed(() => state.shoutoutsProgram.program);
  const upgradeRequired = (feature) => getters.upgradeRequired({ data: program.value.upgrade_data, feature });

  // Lifecycle Hooks
  onMounted(() => {
    if (getQueryParam('from_slack_auth') === 'true') {
      dispatch('setSuccessToast', 'You have successfully granted Donut the required permissions!');
    } else if (getQueryParam('announce') === 'true') {
      commit('updateModal', {
        visible: true,
        subcomponent: 'shoutouts-programs-modals-launch-announcement',
        size: 'xl',
        data: { tags },
      });
    } else if (setupChannel) {
      commit('startConfetti');
      commit('updateModal', {
        visible: true,
        subcomponent: 'shoutouts-programs-modals-setup-success',
        data: { setupChannel },
      });
    }
  });

  // Deactivation
 const deactivationTooltip = computed(() => {
   if (program.value.state !== 'active') return `Donut ${$i18n.t('shoutouts.feature')} is not currently active`;
 });
 const openDeactivateModal = () => {
   if (program.value.state === 'active') {
     window.donut.track('Shoutouts Permissions — Opened Deactivate Modal');
     commit('updateModal', {
       visible: true,
       subcomponent: 'shoutouts-programs-modals-deactivate-warning',
     });
   }
 };
</script>
